import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

//redux
import { useDispatch, useSelector } from "react-redux";

//pages
import pages from "./routes";
import ProtectedRoute from "src/routes/protected-route";

//components
import Loader from "src/components/loader";

//loadable
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";

// css
import "react-day-picker/dist/style.css";

const LoadablePage = loadable(
  ({ directory, user, path }) => {
    return pMinDelay(import(`src/pages/${directory}`), 0);
  },
  {
    cacheKey: (props) => props.directory,
  }
);

const getIndexRoute = pages.filter((route) => route.index === true);
export const indexRoute = getIndexRoute ? getIndexRoute[0] : pages[0];

const App = () => {
  const dispatch = useDispatch();
  const { app, user } = useSelector((state) => ({
    app: state.app,
    user: state.user,
  }));

  // useEffect(() => {
  //   dispatch(getAppData());
  // }, []);

  const createRoute = (path, directory, isPrivate) => {
    let parentRouteElement;
    if (isPrivate) {
      parentRouteElement = (
        <ProtectedRoute>
          <LoadablePage
            path={path}
            user={user}
            fallback={<Loader />}
            directory={directory}
          />
        </ProtectedRoute>
      );
    } else {
      parentRouteElement = (
        <LoadablePage
          user={user}
          path={path}
          fallback={<Loader />}
          directory={directory}
        />
      );
    }
    return parentRouteElement;
  };

  return app.loading ? (
    <Loader />
  ) : (
    <Routes>
      <Route path="/" element={<Navigate to={indexRoute.url} />} />
      {pages.map((parent, index) => {
        const parentDirectory = parent.directory;
        const parentUrl = parent.url;
        const children = parent.children;
        const privateRoute = parent.privateRoute;
        const pageHaveChild = Object.keys(children).length > 0;

        const parentRouteElement = createRoute(
          `/${parentUrl}`,
          parent.directory,
          privateRoute
        );
        if (!pageHaveChild) {
          return (
            <Route
              path={parentUrl}
              element={parentRouteElement}
              key={`route_${parentDirectory}_${index}`}
            />
          );
        } else {
          return (
            <Route
              path={parentUrl}
              element={parentRouteElement}
              key={`parent_route_${parentDirectory}_${index}`}
            >
              <Route
                index
                element={
                  <Navigate
                    to={user && user.data && user.data.permissions[0].value}
                  />
                }
              />
              {user &&
                user.data &&
                user.data.permissions.map((permission) => {
                  const child = children[permission.value];
                  const childUrl = `/${parentUrl}/${child.url}`;
                  const childDirectory = `${parentUrl}/pages/${child.directory}`;

                  const childRouteElement = createRoute(
                    childUrl,
                    childDirectory,
                    privateRoute
                  );
                  return (
                    <Route
                      path={childUrl}
                      element={childRouteElement}
                      key={`child_route_${parentDirectory}_${index}`}
                    />
                  );
                })}
              <Route
                path="*"
                element={<p>you dont have access permission to this page</p>}
              />
            </Route>
          );
        }
      })}
      <Route path="*" element={<p>error directory</p>} />
    </Routes>
  );
};

export default App;
